import React, { useEffect, useState } from 'react'
import ReactSelect from 'react-select'
import Redux from 'app/interface/redux'
import Connect from 'app/redux/connect'
import Basic from 'app/redux/actions/pages/business/basic'
import { NestAPI } from 'app/nestapi'

interface SlackChannel {
  id: string
  name: string
}

interface SalesForceAccount {
  Id: string
  Name: string
}

const Integrations = (props: Redux) => {
  const { main } = props.pages.business
  const [slackChannels, setSlackChannels] = useState<SlackChannel[]>([])
  const [loadingChannels, setLoadingChannels] = useState(true)
  const [sfAccounts, setSfAccounts] = useState<SalesForceAccount[]>([])
  const [loadingAccounts, setLoadingAccounts] = useState(true)

  useEffect(() => {
    NestAPI.get<SlackChannel[]>('businesses/manage/slack/channels')
      .then((channels: any) =>
        setSlackChannels(
          (channels ?? []).sort((a: SlackChannel, b: SlackChannel) => a.name.localeCompare(b.name))
        )
      )
      .catch(() => setSlackChannels([]))
      .finally(() => setLoadingChannels(false))

    NestAPI.get<SalesForceAccount[]>('salesforce/accounts')
      .then((accounts: any) =>
        setSfAccounts(
          (accounts ?? []).sort((a: SalesForceAccount, b: SalesForceAccount) =>
            a.Name.localeCompare(b.Name)
          )
        )
      )
      .catch(() => setSfAccounts([]))
      .finally(() => setLoadingAccounts(false))
  }, [])

  const selectedChannel = slackChannels.find(x => x.id === main.slack_channel_id) ?? null
  const selectedAccount = sfAccounts.find(x => x.Id === main.sf_account_id) ?? null

  return (
    <div className="m-form m-form--fit mb-5 mx-3">
      <div className="m-form__section">
        <div className="m-form__section">
          <div className="m-form__heading">
            <h3 className="m-form__heading-title">Salesforce</h3>
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="form-group m-form__group">
                <label>Salesforce Account</label>
                <ReactSelect
                  isLoading={loadingAccounts}
                  isClearable
                  options={sfAccounts}
                  value={selectedAccount}
                  getOptionLabel={(x: SalesForceAccount) => x.Name}
                  getOptionValue={(x: SalesForceAccount) => x.Id}
                  formatOptionLabel={(x: SalesForceAccount) => (
                    <div>
                      <div>{x.Name}</div>
                      <div style={{ fontSize: '0.85em', color: '#888' }}>id: {x.Id}</div>
                    </div>
                  )}
                  onChange={(option: any) => Basic.update('sf_account_id', option?.Id ?? null)}
                />
              </div>
            </div>
          </div>
          <div className="m-form__seperator m-form__seperator--dashed mt-5 mb-3" />
        </div>

        <div className="m-form__section">
          <div className="m-form__heading">
            <h3 className="m-form__heading-title">Slack</h3>
          </div>
          <div className="row mt-3">
            <div className="col-md-6">
              <div className="form-group m-form__group">
                <label>Slack Channel</label>
                <ReactSelect
                  isLoading={loadingChannels}
                  isClearable
                  options={slackChannels}
                  value={selectedChannel}
                  getOptionLabel={(x: SlackChannel) => x.name}
                  getOptionValue={(x: SlackChannel) => x.id}
                  formatOptionLabel={(x: SlackChannel) => (
                    <div>
                      <div>{x.name}</div>
                      <div style={{ fontSize: '0.85em', color: '#888' }}>id: {x.id}</div>
                    </div>
                  )}
                  onChange={(option: any) => Basic.update('slack_channel_id', option?.id ?? null)}
                />
              </div>
            </div>
          </div>
          <div className="m-form__seperator m-form__seperator--dashed mt-5 mb-3" />
        </div>
      </div>
    </div>
  )
}

export default Connect(Integrations)
